import React, { PureComponent, Fragment } from 'react';
import { object, string, func, number } from 'prop-types';
import { Link } from 'react-router-dom';
import { history } from 'store';
import { graphql } from 'react-apollo';
import { display } from 'actions/banner';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { formatCoordinate } from 'common/utils';
import {
  BannerComponent,
  Button,
  Card,
  Dropdown,
  IconList,
  LevelNav,
  Modal,
  ProgressBar,
} from 'common/components';
import {
  ROUTE_STORAGE,
  ROUTE_STORAGE_EDIT,
  BANNER_IDS,
} from 'common/constants';
import { graphQlToFormErrors } from 'common/utils';
import { MUTATION_DELETE_STORAGE } from 'api/storage';
import { base64url_encode } from 'util/base64';
import * as icons from 'common/svg/icons';
import { SocialShare } from 'containers';

export class StorageDetails extends PureComponent {
  static displayName = 'StorageDetails';

  static propTypes = {
    storage: object,
    deleteStorage: func,
    id: string,
    display: func,
    season: number,
  };

  static defaultProps = {
    deleteAction: () => null,
  };

  state = {
    showStorageModal: false,
  };

  render() {
    const { storage } = this.props;
    const { name } = storage;

    return (
      <div className={'bg--primary'}>
        <BannerComponent
          theme={['strong', 'static', 'mobile-fixed']}
          message={
            <LevelNav
              nav={{
                left: {
                  element: (
                    <Link
                      className="chevron chevron--left chevron--invert"
                      to={ROUTE_STORAGE}
                    >
                      <span className={'visible--desktop'}>Storage List</span>
                    </Link>
                  ),
                },
                center: { label: storage && name },
                right: { element: this._getKebab() },
              }}
            />
          }
        />

        <div className={'column__inner'}>
          <section className={'cardlist__item'}>
            {this._getStorageCard()}
          </section>
        </div>

        {this._getStorageModal()}
      </div>
    );
  }

  _getStorageCard = () =>
    this.props.storage && (
      <Card {...this._getCardData()}>{this._getCardChildren()}</Card>
    );

  _getCardData = () => {
    const { storage } = this.props;
    if (!storage) return null;

    return {
      title: storage.name,
      footer: storage.notes ? storage.notes : '',
    };
  };

  _getCardChildren = () => {
    const { capacity } = this.props.storage;
    const { size, used, type } = capacity;
    const list = this._getIconsArray();

    return (
      <span>
        <IconList list={list} />
        <ProgressBar value={used} max={size} unit={type && type.slice(0, 2)} />
      </span>
    );
  };

  _getIconsArray = () => {
    const { crop, contentValue, location } = this.props.storage;
    const list = [];

    crop &&
      list.push({
        icon: 'crop',
        label: `${crop.name} ${crop.variety ? crop.variety : ''}`,
      });

    list.push({
      icon: 'coordinates',
      label: `${formatCoordinate(location.lat)}, ${formatCoordinate(
        location.lng
      )}`,
    });

    !!Number(contentValue) &&
      list.push({
        icon: 'dollar',
        label: contentValue.value.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      });

    return list;
  };

  _getKebab = () => {
    const { storage, id, season } = this.props;

    return (
      <Fragment>
        <SocialShare id={id} season={season} />
        <Dropdown
          className="level-right"
          theme={['right', 'medium', 'invert']}
          trigger={<icons.kebab />}
        >
          <IconList
            list={[
              {
                label: 'Edit',
                icon: 'edit',
                action: () => {
                  history.push(
                    `${ROUTE_STORAGE_EDIT}/${base64url_encode(
                      storage.id.trim()
                    )}`
                  );
                },
              },
              {
                label: 'Delete',
                icon: 'garbage',
                action: () => this._toggleStorageModal(),
              },
            ]}
            theme={['medium']}
          />
        </Dropdown>
      </Fragment>
    );
  };

  _toggleStorageModal = () => {
    this.setState({ showStorageModal: !this.state.showStorageModal });
  };

  _getStorageModal = () => {
    const { id, deleteStorage } = this.props;
    return (
      this.state.showStorageModal && (
        <Modal
          onToggle={() => this._toggleStorageModal()}
          theme={['narrow']}
          header={'Delete Storage'}
        >
          <small>Are you sure you want to delete this storage?</small>
          <section className={'field__group'}>
            <fieldset className={'field text--center'}>
              <Button
                className="btn btn--primary"
                onClick={() => {
                  deleteStorage(id);
                }}
              >
                Yes
              </Button>
            </fieldset>
            <fieldset className={'field text--center'}>
              <Button
                className="btn"
                onClick={() => this._toggleStorageModal()}
              >
                No
              </Button>
            </fieldset>
          </section>
        </Modal>
      )
    );
  };
}

const mapDispatch = dispatch => bindActionCreators({ display }, dispatch);
const mapState = ({ settings }) => ({ season: settings.season });
const enhance = compose(
  connect(
    mapState,
    mapDispatch
  ),
  graphql(MUTATION_DELETE_STORAGE, {
    props: props => ({
      deleteStorage: id => {
        return props
          .mutate({
            variables: { id },
          })
          .then(() => {
            props.ownProps.display(BANNER_IDS.APP, 'STORAGE DELETED.');
            history.push(ROUTE_STORAGE);
          })
          .catch(graphQlToFormErrors);
      },
      ...props,
    }),
  })
);

export default enhance(StorageDetails);



// WEBPACK FOOTER //
// ./src/containers/StorageDetails/index.js